/*
 * External dependencies
 */
// When dropping the lite-youtube-embed, don't forget to remove the path to the appropriate files in webpack.config.js to the PurgeCSSPlugin plugin
import 'lite-youtube-embed/';
import 'lite-youtube-embed/src/lite-yt-embed.css';

// Bootstrap all modules
//import 'bootstrap/dist/js/bootstrap.bundle.min';

// Or import just what we need
//import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
import bootstrapCarousel from 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
//import 'bootstrap/js/dist/dropdown';
import bootstrapModal from 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/offcanvas';
//import 'bootstrap/js/dist/popover';
//import 'bootstrap/js/dist/scrollspy';
//import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/toast';
//import 'bootstrap/js/dist/tooltip';

/*
 * Internal dependencies
 */

import '../index.html'; // Hack for recompile webpack when html changes (requires null-loader)
import './styles/style.scss';

import LightCountdown from "./components/lightCountdown/lightCountdown";
import lightbox from './components/lightbox';
import bootstrapModalHash from './components/bootstrapModalHash';
import bootstrapCarouselControl from "./components/bootstrapCarouselControl"
import simpleCalculator from './components/simpleCalculator'

document.addEventListener('DOMContentLoaded', () => {
    lightbox();
    new LightCountdown()?.play();
    bootstrapModalHash(bootstrapModal);
    bootstrapCarouselControl(bootstrapCarousel);
    simpleCalculator();

    function updateCountdown() {
        const today = new Date();
        const currentDay = today.getDate();
        const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
        const daysLeft = lastDayOfMonth - currentDay + 1;

        function getNoun(number, one, two, five) {
            let n = Math.abs(number);
            n %= 100;
            if (n >= 5 && n <= 20) {
            return five;
            }
            n %= 10;
            if (n === 1) {
            return one;
            }
            if (n >= 2 && n <= 4) {
            return two;
            }
            return five;
        }

        document.querySelectorAll('.countdown').forEach(container => {
            container.textContent = getNoun(daysLeft, 'Остался', 'Осталось', 'Осталось') + " " + daysLeft + " " + getNoun(daysLeft, 'день', 'дня', 'дней')
        })
    }

    updateCountdown();
    
    setInterval(updateCountdown, 60 * 60 * 1000); 
});
